import { GetWorkspaceCategoryMetricsUsageTotalsResponseDto } from '../../../../src/interface/dtos/app-category-metrics/get-workspace-category-metrics-usage-totals.response.dto';
import { GetWorkspaceCategoryMetricsUsageTotalsRequestDto } from '../../../../src/interface/dtos/app-category-metrics/get-workspace-category-metrics-usage-totals.request.dto';
import { LogManager } from '../../../common/port/log/log.manager.port';
import { GetWorkspaceCategoryMetricsUsageTotalsQuery } from '../../queries/app-category-metrics/get-workspace-category-metrics-usage-totals.query';
import { WorkspaceCategoryMetricsUsageTotalsAggregateRootMapper } from '../../../../src/infrastructure/mappers/app-category-metrics/workspace-category-metrics-usage-totals.aggregate-root.mapper';

export class GetWorkspaceCategoryMetricsUsageTotalsController {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly query: GetWorkspaceCategoryMetricsUsageTotalsQuery,
    protected readonly mapper: WorkspaceCategoryMetricsUsageTotalsAggregateRootMapper
  ) {}

  async get(
    props: GetWorkspaceCategoryMetricsUsageTotalsRequestDto
  ): Promise<GetWorkspaceCategoryMetricsUsageTotalsResponseDto> {
    try {
      const result = await this.query.execute(props);
      return this.mapper.toResponse(result);
    } catch (error) {
      throw new Error(
        `GetWorkspaceCategoryMetricsUsageTotalsController.get encountered an error ${error}`
      );
    }
  }
}
